/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import './RecommendationSettings.scss';
import Select from 'react-select';
import {
  updateRecommendationNotificationSettings,
  getRecommendationNotificationSettings,
} from 'Shared/actions/organizations';
import Switcher from 'Dashboard/Switcher/Switcher';
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';

import TopNavigation from './components/TopNavigation/TopNavigation';
import EmailReminderPreviewGraphic from './email-reminder-preview-graphic.png';
import SlackReminderPreviewGraphic from './slack-reminder-preview-graphic.png';

class Notifications extends Component {
  state = {};

  componentDidMount() {
    const { app, dispatch } = this.props;

    this.setState({ loading: false });
    window.analytics.track('Viewed Recommendation Notification Settings', {
      app_id: app.id,
    });

    this.handleSettingsSubmit = this.handleSettingsSubmit.bind(this);

    dispatch(getRecommendationNotificationSettings());
  }

  handleActiveToggle({ value, onChange, onSubmit }) {
    return () => {
      onChange(!value);
      onSubmit();
    };
  }

  handleSettingsSubmit(key, settings) {
    const { dispatch } = this.props;
    dispatch(updateRecommendationNotificationSettings({ [key]: settings }));
  }

  renderNotificationSetting(setting) {
    if (setting.type === 'select') {
      return (
        <Field name={setting.key} id={setting.key} parse={value => value.value}>
          {({ input: { onChange, value } }) => {
            return (
              <div style={{ width: '180px', display: 'inline-block' }}>
                <Select
                  value={setting.options.find(option => option.value === value)}
                  onChange={onChange}
                  options={setting.options}
                />
              </div>
            );
          }}
        </Field>
      );
    }

    return <div>Unknown setting {setting.key}</div>;
  }

  renderSettingsPanel(key, settings) {
    const currentSettings = Object.fromEntries(settings.map(setting => [setting.key, setting]));
    const initialSettings = Object.fromEntries(
      settings.map(setting => [
        setting.key,
        typeof setting.value === 'number' ? setting.value.toString() : setting.value,
      ])
    );
    const message_label = {
      email: 'an email',
      slack: 'a slack message',
    }[key];

    const title = {
      email: 'Email',
      slack: 'Slack',
      'per_recommendation:slack': 'Slack',
      'per_recommendation:email': 'Email',
    }[key];

    const preview_image = {
      email: EmailReminderPreviewGraphic,
      slack: SlackReminderPreviewGraphic,
    }[key];

    const dimensions_str = {
      email: 'width=800,height=950',
      slack: 'width=630,height=700',
    }[key];

    const is_per_recommendation = key.startsWith('per_recommendation:');

    return (
      <div className="card">
        <Form
          initialValues={initialSettings}
          onSubmit={settings => this.handleSettingsSubmit(key, settings)}
          render={({ dirty, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className="card-body">
                <div className="d-flex align-items-center mb-4" style={{ marginLeft: 'auto' }}>
                  <h4 className="mr-4 mb-0">{title}</h4>
                  <Field name="active" parse={value => value}>
                    {({ input: { onChange, value } }) => (
                      <Switcher
                        id={`switcher-notification-active-${key}`}
                        checked={value}
                        onChange={this.handleActiveToggle({
                          value,
                          onChange,
                          onSubmit: handleSubmit,
                        })}
                      />
                    )}
                  </Field>
                </div>

                {!is_per_recommendation && (
                  <div>
                    Send <span className="font-weight-bold mb-0">{message_label}</span>
                    &nbsp;
                    {this.renderNotificationSetting(currentSettings['frequency'])}
                    &nbsp; at &nbsp;
                    {this.renderNotificationSetting(currentSettings['hour_of_day'])}
                  </div>
                )}

                <div className="row mt-3">
                  <div className="col-sm-4">
                    <button type="submit" className="btn btn-primary mr-3" disabled={!dirty}>
                      Save Changes
                    </button>
                    {preview_image && (
                      <a onClick={() => window.open(preview_image, 'Preview', dimensions_str)}>
                        <button type="button" className="btn btn-primary">
                          View Example
                        </button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}
        />
      </div>
    );
  }

  render() {
    const { recommendation_notification_settings } = this.props;

    if (!recommendation_notification_settings) return <div>Loading ...</div>;

    return (
      <WpPageLayout width="full" className="SalesAssistantNotificationsPage">
        <TopNavigation />
        <WpPageBody>
          <div>
            <h3>Per-Nudge Settings</h3>
            <p className="text-muted">
              Per-nudge notifications are sent to the representative when the nudge is created.
            </p>
            {this.renderSettingsPanel(
              'per_recommendation:slack',
              recommendation_notification_settings['per_recommendation:slack']
            )}

            <h3 className="mt-5">Reminder Settings</h3>
            <p className="text-muted">
              The Sales Assistant Reminders are sent to each representative at a regular time to notify them of any
              unresolved nudges.
            </p>

            {this.renderSettingsPanel('email', recommendation_notification_settings['email'])}
            <p />
            {this.renderSettingsPanel('slack', recommendation_notification_settings['slack'])}
          </div>
        </WpPageBody>
      </WpPageLayout>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
  recommendation_notification_settings: state.organization.recommendation_notification_settings,
});

export default connect(mapStateToProps)(Notifications);
